// extracted by mini-css-extract-plugin
export default {"avatar_wrapper":"avatar-with-actions_avatar_wrapper__OLnus","avatar_overlay":"avatar-with-actions_avatar_overlay__tgTc9","icon_btn":"avatar-with-actions_icon_btn__WIPHz"};